module.exports = __webpack_public_path__ + "static/img/auth_student_down.c86173f0.png";